export const LexiqueFr = [
  {
    Alphab: 'A',
    words: [
      {
        title: 'ACCIDENT: ',
        description:
          'Evènement soudain, imprévisible et involontaire, extérieur à son auteur ou à la victime, qui provoque des dommages corporels, matériels et/ou immatériels.',
      },
      {
        title: 'AGENT GENERAL D’ASSURANCES: ',
        description:
          'C’est une personne physique qui représente dans un secteur géographique, selon un traité, une société d’assurances dont il est mandataire. Ses actes engagent la société qu’il représente.',
      },
      {
        title: 'ASSISTANCE: ',
        description:
          'opération par laquelle une société dite d’assistance, soumise au contrôle de l’Etat, s’engage à porter assistance aux personnes assurées, lorsqu’elles se trouvent en difficulté, notamment à l’occasion de déplacements.',
      },
      {
        title: 'ASSURANCE VIE: ',
        description:
          'garantie consistant à rembourser les primes nettes, augmentées éventuellement des intérêts, au décès de l’assuré avant l’échéance d’un contrat souscrit en cas de vie.',
      },
      {
        title: 'ASSURANCE des DOMMAGES: ',
        description:
          'ont pour but de garantir l’assuré contre les conséquences d’un événement pouvant causer des dommages à son patrimoine ou à celui d’autrui. On distingue :\nLes assurances des choses : incendie, tierce, dégâts des eaux …\nEt les assurances de responsabilité: RC automobile…\nASSURANCE DE PERSONNES : elles comprennent:\nLes assurances sur la vie: assurance garantissant les risques dont la survenance dépend de la survie ou du décès de l’assuré,\nEt les assurances contre les incendies corporels: Individuelle, P.T.A., ... On peut inclure dans les assurances des personnes la maternité et les assurances contre la maladie, l’incapacité et l’invalidité.\nATTESTATION D’ASSURANCE (AUTOMOBILE): Document qui représente une présomption d’assurance, elle n’est valable que sur le territoire marocain.',
      },
      {
        title: 'AVENANT: ',
        description:
          'Modification apportée au contrat, justifiée par un changement de nature du risque ou d’un changement des garanties souscrites. Un avenant peut générer soit une prime additionnelle (comptant) soit un remboursement (ristourne) soit aucun changement de prime (comptant nul).',
      },
      {
        title: 'AVIS D’ECHEANCE: ',
        description:
          'Document adressé à un assuré pour l’inviter à payer une prime ou une cotisation.',
      },
      {
        title: 'AVIS DE SINISTRE: ',
        description:
          'obligation faite à l’assuré d’informer l’assureur, dés qu’il en a eu connaissance et au plus tard dans le délai prévu au contrat d’assurance, de tout sinistre de nature à mettre en jeu la garantie de l’assureur.',
      },
      {
        title: 'AYANT DROIT: ',
        description:
          'personne habilitée légalement à exercer les droits d’une autre personne. On dit généralement que les héritiers sont des ayants droit de la personne décédée.',
      },
    ],
  },
  {
    Alphab: 'B',
    words: [
      {
        title: 'BENEFICIAIRE: ',
        description:
          "Tierce personne physique ou morale au profit de laquelle l'assurance a été contractée. Elle peut être nommément désignée aux conditions particulières du contrat ou bien apparaître dans les conditions générales sous les termes de : conjoint survivant, d'ayants droit, ou encore d’héritier né ou à naître... Le bénéficiaire recevra l'indemnité due par l'assureur en cas de réalisation du risque assuré.",
      },
      {
        title: 'B. D. G. ou BRIS DE GLACE: ',
        description:
          'c’est la garantie accordée en automobile pour le bris des glaces du véhicule (non compris les rétroviseurs et les glaces optiques bien qu’ils soient en verre).',
      },
      {
        title: 'B. D. M. ou BRIS DE MACHINES: ',
        description:
          'en risques techniques désigne une police qui couvre les dommages subis par les machines, généralement dans les usines, les manufactures...',
      },
      {
        title: 'BENEFICIAIRE: ',
        description:
          'personne physique ou morale qui reçoit l’indemnité ou le capital versé par l’assureur.',
      },
      {
        title: 'BONUS / MALUS ou CRM: ',
        description:
          'En termes officiels, c’est le régime de réduction/majoration des primes d’assurance d’un contrat automobile en fonction du nombre d’accidents responsables déclarés à l’assureur par un assuré.',
      },
    ],
  },
  {
    Alphab: 'C',
    words: [
      {
        title: 'CAPITAL ASSURE: ',
        description:
          'valeur déclarée au contrat et constituant la limite de l’engagement de l’assureur, quelle que soit l’importance du dommage.',
      },
      {
        title: 'CARTE INTERNATIONALE : AUTOMOBILE: ',
        description:
          'elle est remise à l’assuré titulaire d’un contrat d’assurance automobile dans le cadre de la responsabilité civile pour lui permettre de circuler dans certains pays étrangers. On distingue :\nLa carte verte destinée pour certains pays européens;\nEt la carte orange pour certains pays africains.',
      },
      {
        title: 'CIVILEMENT RESPONSABLE: ',
        description:
          ' une personne est dite civilement responsable lorsqu’elle doit répondre des conséquences civiles de la responsabilité d’une autre personne.En automobile désigne le propriétaire du véhicule ; la carte grise comporte le nom du civilement responsable.',
      },
      {
        title: 'CLAUSE: ',
        description: 'Disposition particulière applicable à un contrat.',
      },
      {
        title: 'COLLISION: ',
        description: 'choc consécutif à la rencontre violente(de deux corps). ',
      },
      {
        title: 'CONDITIONS GENERALE: ',
        description:
          'Dispositions, pré imprimées, définissant le cadre et les principes généraux de fonctionnement du contrat.',
      },
      {
        title: 'CONDITIONS PARTICULIERE: ',
        description:
          ' Elles précisent le risque couvert, les valeurs garanties, les garanties souscrites, les franchises, l’identité et l’adresse du souscripteur, éventuellement de l’assuré et du bénéficiaire, la date d’effet, la durée du contrat, le montant de la prime ou de la cotisation et des taxes.',
      },
      {
        title: 'CONSTAT AMIABL: ',
        description:
          'document établi contradictoirement par les antagonistes(généralement sur les lieux), constatant un accident aux conséquences purement matérielles et permettant, dans certaines circonstances aux assureurs R C, d’avancer les fonds à leurs assurés dans le cadre de la convention indemnisation directe.',
      },
      {
        title: 'CONTRAT ou POLICE D’ASSURANC: ',
        description:
          'Document qui définit les engagements des deux parties(assureur et assuré) et qui est signé par celles- ci.Un contrat d’assurance se compose obligatoirement des documents suivants:\nLes conditions ou dispositions générales qui définissent le cadre et les principes généraux de fonctionnement du contrat.\nLes conditions particulières qui sont signées par l’assureur et l’assuré,\nLes conventions ou dispositions spéciales qui définissent les garanties pouvant être accordées par le contrat(seules sont acquises celles dont mention est faite aux conditions particulières).\nÉventuellement les annexes, intercalaires, clauses dont il fait mention aux conditions particulières.',
      },
      {
        title: 'CONTRE EXPERTISE: ',
        description:
          'en cas de litige, de désaccord ou pour sauvegarder leurs intérêts réciproques, les parties(assureurs, assurés, tiers...) peuvent provoquer une contre - expertise : constatation des dommages, des blessures subies par les victimes contradictoirement par l’expert et par le contre expert.',
      },
      {
        title: 'COTISATION: ',
        description:
          'somme due par le souscripteur d’un contrat d’assurance en contre partie des garanties accordées par l’assureur.',
      },
      {
        title: "COURTIER D'ASSURANCES :",
        description:
          'Professionnel indépendant ayant la qualité de commerçant, le courtier d’assurances sert d’intermédiaire entre ses clients et les compagnies d’assurances, son objectif étant in fine de trouver les produits les mieux adaptées à sa clientèle.\nLe courtier représente ses clients et défend leurs intérêts.Il les conseille, négocie avec les compagnies d’assurances et les assiste dans le règlement des sinistres.\n Mandataire de son client, il est rémunéré par la compagnie d’assurances en tant qu’apporteur d’affaires.Sa responsabilité civile professionnelle peut être recherchée s’il manque à son devoir de conseil.Toutefois, s’il se présente comme le mandataire d’une compagnie d’assurances, il engage alors la responsabilité de celle - ci.',
      },
    ],
  },
  {
    Alphab: 'D',
    words: [
      {
        title: 'DATE D’EFFET: ',
        description:
          'Date à laquelle le contrat (ou l’avenant) prend effet (prise d’effet de la garantie)',
      },
      {
        title: 'D.D.E.ou DEGATS DES EAU: ',
        description:
          ' police risques divers ou garantie supplémentaire dans certaines polices couvrant les dommages subis par le bâtiment, le mobilier ou le matériel suite à des fuites d’eau...',
      },
      {
        title: 'DEDOMMAGEMEN: ',
        description:
          'c’est la procédure d’indemnisation d’une personne dans le cadre de la responsabilité civile.',
      },
      {
        title: 'DECLARATION DU RISQU: ',
        description:
          'Le fait pour un assuré, de fournir à l’assureur toutes les informations nécessaires à la tarification et à l’établissement du contrat.',
      },
      {
        title: 'DEFENSE & RECOUR: ',
        description:
          'garantie facultative existant en automobile et dans certaines polices obligeant l’assureur:\nEn cas de poursuites pénales engagées contre son client, à le défendre en constituant un avocat;\nEt à exercer un recours amiable ou judiciaire pour dé fendre ses intérêts.',
      },
      {
        title: 'DETERIORATIONS IMMOBILIERE: ',
        description:
          'dégâts subis par les bâtiments, aux embellissements, aux portes..., des locaux assurés.',
      },
      {
        title: 'DOMMAGES: ',
        description: 'Perte ou préjudice subi par une personne ou un bien.',
      },
      {
        title: 'DOMMAGES CORPOREL: ',
        description: 'Dommages subis par les personnes physiques.',
      },
      {
        title: 'DOMMAGES ELECTRIQUES: ',
        description:
          'accident d’origine électrique causant des dommages aux appareils électriques et aux canalisations électriques non enterrés.',
      },
      {
        title: 'DOMMAGES IMMATERIEL: ',
        description:
          'Dommages qui résultent de la privation de jouissance d’un droit, de l’interruption d’un service ou d’une perte de bénéfice espéré.',
      },
      {
        title: 'DOMMAGES MATERIELS: ',
        description:
          'Dommages atteignant les biens meubles ou immeubles, les animaux.',
      },
      {
        title: 'DOMMAGES COLLISION: ',
        description:
          ' garantie optionnelle couvrant les dommages subis par le véhicule assuré suite à un accident avec un autre véhicule ou un piéton que l’assuré soit responsable ou non.',
      },
      {
        title: 'DUREE DU CONTRAT: ',
        description:
          ' Période pour laquelle est souscrit le contrat, soit au maximum un an pour tous les contrats souscrits par les particuliers(en dehors de l’assurance maladie).Pour les professionnels, la loi ne prévoit pas de durée légale.',
      },
    ],
  },
  {
    Alphab: 'E',
    words: [
      {
        title: 'ECHEANCE (de PRIME ou de COTISATION) : ',
        description: 'date à laquelle la cotisation est due.',
      },
      {
        title: 'EFFET : ',
        description:
          'date à partir de laquelle le risque est pris en charge par l’assureur.',
      },
      {
        title: 'EFFRACTION: ',
        description:
          'forcement ou la destruction de tout dispositif de fermeture ou de toute espèce de clôture.',
      },
      {
        title: 'EPAVE :(véhicule épave): ',
        description:
          "lorsque le coût des réparations suite à un sinistre automobile garanti dépasse la valeur du véhicule au jour du sinistre, le véhicule est déclaré épave (VEI = Véhicule Economiquement Irréparable) par l'expert qui plafonne son évaluation à la Valeur à dire d'expert .",
      },
      {
        title: 'ETENDUE TERRITORIALE: ',
        description:
          "L'étendue territoriale définit la portée géographique de la couverture, et par exemple, précise le nom des pays dans lesquels les garanties s'appliquent et ceux dans lesquels les garanties ne s'appliquent pas. Ces limites sont soit imposées par la loi, ou alors décidées par l'assureur pour maîtriser son risque.",
      },
      {
        title: 'EVALUATION : ',
        description:
          'coût approximatif d’un sinistre.Les évaluations des dommages permettent de déterminer le préjudice subi par les assurés ou par les tiers et de fixer le montant de leurs indemnités.',
      },
      {
        title: 'EVENEMENT : ',
        description:
          'toute circonstance susceptible de provoquer ou ayant provoqué un sinistre.',
      },
      {
        title: 'EXAMEN MEDICAL : ',
        description:
          'mesures d’instruction confiée à un médecin spécialisé dans l’expertise médicale, dans le but de renseigner l’assureur sur l’importance du préjudice corporel d’une victime.\nEn cas d’accident de la circulation, elle est faite à la demande de l’assureur du véhicule impliqué pour lui permettre de présenter à la victime une offre d’indemnité, dite offre transactionnelle.',
      },
      {
        title: 'EXCLUSION : ',
        description:
          'Ce qui n’est pas garanti par un contrat.Exemples : dommages volontaires, dommages causés à soi - même, amendes etc.Certaines exclusions sont absolues et d’autres sont relatives, c’est à dire qu’elles peuvent être supprimées moyennant surprime.',
      },
      {
        title: 'EXPERTISE : ',
        description:
          'Intervention, travail et conclusion de l’expert chargé par l’assureur de déterminer le montant des dommages subis par l’assuré lors d’un sinistre.L’expertise est dite «judiciaire» si l’expert est nommé par un tribunal.',
      },
      {
        title: 'EXPERTISE CONTRADICTOIRE : ',
        description:
          "La société d'assurances désigne un expert ; l'assuré en choisit un autre.Les experts tenteront alors de se mettre d'accord. En cas de désaccord, ils en désignent un troisième et les décisions sont prises à la majorité.",
      },
      {
        title: 'EXTENSION DE GARANTIE: ',
        description:
          'garantie ajoutée au contrat de base à la demande du souscripteur, et généralement moyennant un complément de prime.',
      },
    ],
  },
  {
    Alphab: 'F',
    words: [
      {
        title: 'FAUSSE DECLARATION : ',
        description:
          'Déclaration inexacte de l’assuré sur les éléments servant de base à l’établissement du contrat ou sur les antécédents. La fausse déclaration peut, suivant les circonstances, donner lieu à l’établissement d’un nouveau contrat, à sa résiliation ou à sa nullité, ou au règlement partiel d’un sinistre.',
      },
      {
        title: 'FERME: ',
        description:
          'par opposition aux polices renouvelables par tacite reconduction, les polices dites fermes, sont résiliées automatiquement à leur échéance.',
      },
      {
        title: 'FORFAIT:  DOMMAGES: ',
        description:
          'il peut arriver que les experts avec les parties lésées n’arrivent pas à déterminer avec exactitude le montant des dommages subis.Dans ce cas, ils s’arrangent pour attribuer un forfait d’un commun accord pour mettre fin au litige.',
      },
      {
        title: 'F.M.P.ou FRAIS MEDICAUX ET PHARMACEUTIQUES: ',
        description:
          'ce sont les frais engagés par la victime pour se soigner: honoraires des médecins, médicaments, frais des cliniques...pris en charge par les assureurs loi, par les assurances de personnes: individuelle, PTA, Maladie...et par la R.C.automobile.',
      },
      {
        title: ' FRACTIONNEMENT : ',
        description:
          'Périodicité de paiement d’une prime.Il peut être annuel, semestriel, trimestriel...avec une légère augmentation de la prime.',
      },
      {
        title: 'FRANCHISE: ',
        description:
          'Part de dommage que l’assuré conserve à sa charge.Elle peut être fixe ou proportionnelle au montant des dommages avec minimum / maximum.Elle peut être absolue ou relative.',
      },
    ],
  },
  {
    Alphab: 'G',
    words: [
      {
        title: 'GARAGES CONVENTIONNES : ',
        description:
          'pour rendre un meilleur service à nos assurés, certains réparateurs automobiles ont été agréés par notre Compagnie dans plusieurs villes du royaume pour réparer à nos charges, sous certaines conditions, leur(s) véhicule(s).',
      },
      {
        title: 'GARANTIE : ',
        description:
          'Engagement de l’assureur de couvrir un risque.L’assureur délivre ou accorde sa garantie pour tel ou tel risque.',
      },
    ],
  },
  {
    Alphab: 'I',
    words: [
      {
        title: 'INCAPACITES : ',
        description: 'on distingue plusieurs incapacités : ',
      },
      {
        title: 'I.P.P.ou INCAPACITE PERMANENTE PARTIELLE : ',
        description:
          'Diminution de l’intégrité physique d’une personne, par suite de maladie ou d’accident, et dont l’état ne peut plus évoluer, ni positivement, ni négativement, c’est à dire que l’on dit que son état est consolidé.Elle est exprimée par les médecins en pourcentage.',
      },
      {
        title: 'I.P.T.ou INCAPACITE PERMANENTE TOTALE : ',
        description:
          'dans ce cas, la personne est dans l’incapacité de se livrer à une quelconque activité lui procurant gain ou profit telles que la cécité, la folie, la paraplégie...elle équivaut à 100 % d’I.P.P…',
      },
      {
        title:
          'I.T.T.ou INCAPACITE TOTALE TEMPORAIRE ou encore INDEMNITE JOURNALIERE : ',
        description:
          'Allocation versée à une personne mise dans l’incapacité de se livrer à ses occupations habituelles(professionnelles ou non), pour chaque jour d’incapacité.',
      },
      {
        title: 'INCENDIE : ',
        description: 'Feu qui se propage et fait des ravages.',
      },
      {
        title: 'INDEMNITE : ',
        description:
          'Somme qui, conformément aux dispositions du contrat, est versée par l’assureur à l’occasion d’un sinistre, après déduction éventuelle de la vétusté et de la franchise.\nL’indemnité peut aussi être versée à la victime d’un accident causé par un tiers.',
      },
      {
        title: 'INTERMEDIAIRE : ',
        description:
          'L’agent général, ou le courtier qui fait souscrire le contrat et peut effectuer les tâches d’encaissement et de gestion.',
      },
    ],
  },
  {
    Alphab: 'M',
    words: [
      {
        title: 'MISE EN DEMEURE (POUR NON PAIEMENT DE PRIME) : ',
        description:
          'Injonction de payer adressée par l’assureur à l’assuré qui n’a pas réglé une prime dans les délais impartis.\nLa mise en demeure doit être faite dans les conditions fixées par le Code des Assurances.Elle a pour effet de suspendre les garanties du contrat dans le délai de 20 jours et de le résilier 10 jours après.',
      },
      {
        title: 'MULTIRISQUE: ',
        description:
          'contrats qui comportent plusieurs garanties spécifiques:\nIncendie, Vol, Dégât des eaux, Responsabilité Civile…',
      },
    ],
  },
  {
    Alphab: 'N',
    words: [
      {
        title: 'NULLITE DU CONTRAT: ',
        description:
          'quand le contrat est entaché par une fausse déclaration grave de la part de l’assuré –dans le but d’induire en erreur l’assureur – le contrat en question est sensé n’avoir jamais existé et les primes réglées restent acquises à l’assureur en guise d’indemnité.',
      },
    ],
  },
  {
    Alphab: 'O',
    words: [
      {
        title: 'OBLIGATIONS CONTRACTUELLES : ',
        description:
          'selon le contrat conclu, l’assuré s’oblige à payer la prime ou la cotisation et l’assureur à payer l’indemnité à son client en cas de réalisation du risque.',
      },
    ],
  },
  {
    Alphab: 'P',
    words: [
      {
        title: 'PARTS DE RESPONSABILITE : ',
        description:
          'En matière de responsabilité civile, les indemnités sont calculées en tenant compte du taux de responsabilité incombant à l’auteur du fait dommageable.',
      },
      {
        title: 'POLICE : ',
        description:
          'Document qui matérialise, constate la preuve de l’accord et des engagements de l’assureur et du souscripteur pour la couverture du risque.\nLa police d’assurance est constituée des :\n- Condition Générales qui sont habituellement des dispositions pré imprimées, définissant le cadre et les principes généraux du contrat et des :\n- Conditions Particulières qui sont des dispositions spéciales qui adaptent la police d’assurance à chaque cas particulier (souscripteur, assuré, adresse, capitaux, conditions tarifaires...).\nIl y a lieu de signaler qu’en cas de contradiction entre les deux Conditions, c’est les Conditions Particulières qui prévalent.',
      },
      {
        title: 'PREAVIS : ',
        description:
          'Délai que doit respecter la partie qui demande la résiliation pour que celle-ci soit acceptable par l’autre partie. Ce délai impératif diffère d’une branche à une autre.',
      },
      {
        title: 'PREJUDICE : ',
        description: 'Dommage subi par une personne physique ou morale.',
      },
      {
        title: 'PRIME D’ASSURANCE ou COTISATION : ',
        description:
          'somme versée par l’assuré à l’assureur en contrepartie de la prise en charge du risque.',
      },
      {
        title:
          'P. T. A. ou PERSONNES TRANSPORTEES AUTOMOBILES ou encore SECURITE ROUTIERE : ',
        description:
          'elle couvre 5 personnes, quelles qu’elles soient (tiers ou non), blessées dans le véhicule assuré suite à un accident de la circulation.',
      },
    ],
  },
  {
    Alphab: 'Q',
    words: [
      {
        title: 'QUITTANCE D’INDEMNITE : ',
        description:
          'Document soumis à la signature de l’assuré ou d’un tiers en contrepartie du paiement d’un sinistre.',
      },
      {
        title: 'QUITTANCE DE PRIME (ou de COTISATION) : ',
        description:
          'Document remis à l’assuré en contrepartie du paiement de sa prime (ou de sa cotisation).',
      },
    ],
  },
  {
    Alphab: 'R',
    words: [
      {
        title: 'RECOURS : ',
        description:
          "Réclamation d'une victime auprès du responsable de son préjudice.",
      },
      {
        title: 'RENTE: ',
        description:
          'en accidents de travail ou assurance vie: montant distribué aux bénéficiaires périodiquement. Elle peut être viagère, toute la vie du bénéficiaire, comme elles peuvent être limitées dans le temps.',
      },
      {
        title: 'RESILIATION : ',
        description:
          ' Dénonciation du contrat. Elle est habituellement demandée par l’une des parties à l’échéance principale. Elle peut être demandée en dehors de cette date lors de circonstances particulières :\n- Pour l’assuré en cas de disparition ou de modification du risque,\n- Pour l’assureur, en cas d’aggravation du risque, en cas de sinistre ou en cas de non paiement de la prime par l’assuré.',
      },
      {
        title: 'RESPONSABILITE CIVILE : ',
        description:
          "L'assurance de responsabilité civile a pour objet de garantir les conséquences pécuniaires de la responsabilité civile encourue par les personnes couvertes par le contrat. ",
      },
      {
        title: 'RESPONSABILITE CIVILE(vie privée) : ',
        description:
          "Obligation légale pour toute personne de réparer les dommages causés à autrui.Les dommages causés par son fait, par sa négligence, son imprudence, par les enfants, préposés, animaux ou choses que l'on a sous sa garde, immeubles dont on est propriétaire.",
      },
      {
        title: 'RISQUE : ',
        description:
          'Evènement futur et aléatoire contre lequel l’assuré veut se prémunir.C’est aussi le bien sur lequel porte l’assurance.',
      },
    ],
  },
  {
    Alphab: 'S',
    words: [
      {
        title: 'SINISTRE : ',
        description:
          "Réalisation de l'événement couvert par le contrat et qui donne lieu aux prestations assurées : indemnité, capital ou rente, assistance...",
      },
      {
        title: 'SOUSCRIPTEUR : ',
        description:
          "Personne qui signe le contrat et paie les cotisations.Parfois à distinguer de l'assuré ou du bénéficiaire.",
      },
      {
        title: 'SUBROGATION: ',
        description:
          "Lorsque le dommage subi par l'assuré est le fait d'un tiers, l'assureur indemnise son assuré et peut exercer un recours contre le tiers responsable pour son propre compte à concurrence du montant de l'indemnité qu'il a versé. On dit que l'assureur est 'subrogé' dans les droits et actions de l'assuré contre le tiers responsable.",
      },
      {
        title: 'SUSPENSION DES GARANTIES : ',
        description:
          'Interruption provisoire de la garantie du contrat.Elle suspend temporairement les obligations de l’assureur mais pas celles de l’assuré notamment en matière de paiement des primes.',
      },
      {
        title: 'SUSPENSION DU CONTRAT: ',
        description:
          'Interruption provisoire des obligations découlant du contrat.Elle est demandée par l’assuré et s’effectue après accord écrit de l’assureur.',
      },
    ],
  },
  {
    Alphab: 'T',
    words: [
      {
        title: 'TACITE RECONDUCTION : ',
        description:
          'Renouvellement automatique du contrat à l’expiration de la durée initiale. Un contrat d’un an avec tacite reconduction sera reconduit d’année en année sauf dénonciation par l’une des deux parties.',
      },
      {
        title: 'TAXE(d’assurance) : ',
        description:
          'impôt calculé en pourcentage(%) de la prime, et recouvré par les entreprises d’assurances pour le compte du Trésor Public.',
      },
      {
        title: 'TERRITORIALITE : ',
        description:
          'les polices, la Carte Verte ainsi que la Carte Orange font état des pays où peut s’exercer valablement les garanties.',
      },
      {
        title: 'TICKET MODERATEUR : ',
        description:
          "C'est ce qui reste à la charge de l'assuré social.C'est donc l'écart entre le tarif de convention et le montant remboursé par la Sécurité Sociale.C'est ce qui n'a pas été remboursé par la Sécurité Sociale et qui peut faire l'objet d'un remboursement complémentaire grâce à une complémentaire maladie(une 'mutuelle').",
      },
      {
        title: 'TIERS : ',
        description:
          'se dit de toute personne avec laquelle on n’a aucun lien juridique.Les personnes ayant la qualité de TIERS, peuvent prétendre à une indemnisation en matière de Responsabilité Civile.',
      },
      {
        title: 'TOUS RISQUES : ',
        description:
          'En Automobile, police englobant toutes les garanties: R.C., Tierce, Vol, Incendie, BDG et Défense Recours.',
      },
    ],
  },
  {
    Alphab: 'V',
    words: [
      {
        title: 'VALEUR : ',
        description: 'c’est la valeur marchande d’un objet. On distingue : ',
      },
      {
        title: 'VALEUR ASSUREE : ',
        description:
          'somme déclarée par les assurés à la souscription d’un contrat.',
      },
      {
        title: 'VALEUR A NEUF : ',
        description:
          "La valeur à neuf est, pour le bâtiment, le prix coûtant de sa reconstruction à neuf (ou de sa réparation), y compris les taxes, les honoraires d'architecte, et pour le mobilier, le prix coûtant de sa reconstitution à neuf (ou de sa réparation).",
      },
      {
        title: 'VALEUR de REMPLACEMENT : ',
        description:
          'Coût réel d’un bien de même nature, de même ancienneté et dans le même état d’entretien que le bien endommagé.',
      },
      {
        title: 'VALEUR VENALE : ',
        description:
          "La valeur vénale est le prix d'un bien que l'assuré obtiendrait normalement s'il le mettait en vente sur le marché national.",
      },
      {
        title: 'VANDALISME: ',
        description:
          'Détériorations ou destructions mobilières ou immobilières commises volontairement par un tiers.',
      },
      {
        title: 'VEHICULE TERRESTRE A MOTEUR: AUTOMOBILE: ',
        description:
          'tout véhicule mu par un moteur doit être assuré en responsabilité civile auprès d’une compagnie d’assurance ou une mutuelle.\nLa conduite des véhicules dont la cylindrée dépasse 49 cm3 nécessite un permis de conduire.',
      },
      {
        title: 'VETUSTE : ',
        description:
          'Valeur de la dépréciation d’un bien par rapport à sa valeur à neuf.Elle n’est pas proportionnelle à l’ancienneté du bien, mais estimée suivant l’état réel du bien par rapport à un bien neuf de même nature.',
      },
      {
        title: 'VOL : ',
        description:
          'le code pénale qualifie le vol de: « soustraction frauduleuse d’un objet appartenant à autrui ».Le vol se caractérise donc par le fait de s’arroger la détention matérielle d’une chose contre le gré de son propriétaire ou de son détenteur naturel, peu importe que l’objet soit ensuite détruit ou abandonné.',
      },
    ],
  },
];
export const LexiqueAr = [
  {
    Alphab: 'A',
    words: [
      {
        title: 'ACCIDENT: ',
        description:
          'Evènement soudain, imprévisible et involontaire, extérieur à son auteur ou à la victime, qui provoque des dommages corporels, matériels et/ou immatériels.',
      },
      {
        title: 'AGENT GENERAL D’ASSURANCES: ',
        description:
          'C’est une personne physique qui représente dans un secteur géographique, selon un traité, une société d’assurances dont il est mandataire. Ses actes engagent la société qu’il représente.',
      },
      {
        title: 'ASSISTANCE: ',
        description:
          'opération par laquelle une société dite d’assistance, soumise au contrôle de l’Etat, s’engage à porter assistance aux personnes assurées, lorsqu’elles se trouvent en difficulté, notamment à l’occasion de déplacements.',
      },
      {
        title: 'ASSURANCE VIE: ',
        description:
          'garantie consistant à rembourser les primes nettes, augmentées éventuellement des intérêts, au décès de l’assuré avant l’échéance d’un contrat souscrit en cas de vie.',
      },
      {
        title: 'ASSURANCE des DOMMAGES: ',
        description:
          'ont pour but de garantir l’assuré contre les conséquences d’un événement pouvant causer des dommages à son patrimoine ou à celui d’autrui. On distingue :\nLes assurances des choses : incendie, tierce, dégâts des eaux …\nEt les assurances de responsabilité: RC automobile…\nASSURANCE DE PERSONNES : elles comprennent:\nLes assurances sur la vie: assurance garantissant les risques dont la survenance dépend de la survie ou du décès de l’assuré,\nEt les assurances contre les incendies corporels: Individuelle, P.T.A., ... On peut inclure dans les assurances des personnes la maternité et les assurances contre la maladie, l’incapacité et l’invalidité.\nATTESTATION D’ASSURANCE (AUTOMOBILE): Document qui représente une présomption d’assurance, elle n’est valable que sur le territoire marocain.',
      },
      {
        title: 'AVENANT: ',
        description:
          'Modification apportée au contrat, justifiée par un changement de nature du risque ou d’un changement des garanties souscrites. Un avenant peut générer soit une prime additionnelle (comptant) soit un remboursement (ristourne) soit aucun changement de prime (comptant nul).',
      },
      {
        title: 'AVIS D’ECHEANCE: ',
        description:
          'Document adressé à un assuré pour l’inviter à payer une prime ou une cotisation.',
      },
      {
        title: 'AVIS DE SINISTRE: ',
        description:
          'obligation faite à l’assuré d’informer l’assureur, dés qu’il en a eu connaissance et au plus tard dans le délai prévu au contrat d’assurance, de tout sinistre de nature à mettre en jeu la garantie de l’assureur.',
      },
      {
        title: 'AYANT DROIT: ',
        description:
          'personne habilitée légalement à exercer les droits d’une autre personne. On dit généralement que les héritiers sont des ayants droit de la personne décédée.',
      },
    ],
  },
  {
    Alphab: 'B',
    words: [
      {
        title: 'BENEFICIAIRE: ',
        description:
          "Tierce personne physique ou morale au profit de laquelle l'assurance a été contractée. Elle peut être nommément désignée aux conditions particulières du contrat ou bien apparaître dans les conditions générales sous les termes de : conjoint survivant, d'ayants droit, ou encore d’héritier né ou à naître... Le bénéficiaire recevra l'indemnité due par l'assureur en cas de réalisation du risque assuré.",
      },
      {
        title: 'B. D. G. ou BRIS DE GLACE: ',
        description:
          'c’est la garantie accordée en automobile pour le bris des glaces du véhicule (non compris les rétroviseurs et les glaces optiques bien qu’ils soient en verre).',
      },
      {
        title: 'B. D. M. ou BRIS DE MACHINES: ',
        description:
          'en risques techniques désigne une police qui couvre les dommages subis par les machines, généralement dans les usines, les manufactures...',
      },
      {
        title: 'BENEFICIAIRE: ',
        description:
          'personne physique ou morale qui reçoit l’indemnité ou le capital versé par l’assureur.',
      },
      {
        title: 'BONUS / MALUS ou CRM: ',
        description:
          'En termes officiels, c’est le régime de réduction/majoration des primes d’assurance d’un contrat automobile en fonction du nombre d’accidents responsables déclarés à l’assureur par un assuré.',
      },
    ],
  },
  {
    Alphab: 'C',
    words: [
      {
        title: 'CAPITAL ASSURE: ',
        description:
          'valeur déclarée au contrat et constituant la limite de l’engagement de l’assureur, quelle que soit l’importance du dommage.',
      },
      {
        title: 'CARTE INTERNATIONALE : AUTOMOBILE: ',
        description:
          'elle est remise à l’assuré titulaire d’un contrat d’assurance automobile dans le cadre de la responsabilité civile pour lui permettre de circuler dans certains pays étrangers. On distingue :\nLa carte verte destinée pour certains pays européens;\nEt la carte orange pour certains pays africains.',
      },
      {
        title: 'CIVILEMENT RESPONSABLE: ',
        description:
          ' une personne est dite civilement responsable lorsqu’elle doit répondre des conséquences civiles de la responsabilité d’une autre personne.En automobile désigne le propriétaire du véhicule ; la carte grise comporte le nom du civilement responsable.',
      },
      {
        title: 'CLAUSE: ',
        description: 'Disposition particulière applicable à un contrat.',
      },
      {
        title: 'COLLISION: ',
        description: 'choc consécutif à la rencontre violente(de deux corps). ',
      },
      {
        title: 'CONDITIONS GENERALE: ',
        description:
          'Dispositions, pré imprimées, définissant le cadre et les principes généraux de fonctionnement du contrat.',
      },
      {
        title: 'CONDITIONS PARTICULIERE: ',
        description:
          ' Elles précisent le risque couvert, les valeurs garanties, les garanties souscrites, les franchises, l’identité et l’adresse du souscripteur, éventuellement de l’assuré et du bénéficiaire, la date d’effet, la durée du contrat, le montant de la prime ou de la cotisation et des taxes.',
      },
      {
        title: 'CONSTAT AMIABL: ',
        description:
          'document établi contradictoirement par les antagonistes(généralement sur les lieux), constatant un accident aux conséquences purement matérielles et permettant, dans certaines circonstances aux assureurs R C, d’avancer les fonds à leurs assurés dans le cadre de la convention indemnisation directe.',
      },
      {
        title: 'CONTRAT ou POLICE D’ASSURANC: ',
        description:
          'Document qui définit les engagements des deux parties(assureur et assuré) et qui est signé par celles- ci.Un contrat d’assurance se compose obligatoirement des documents suivants:\nLes conditions ou dispositions générales qui définissent le cadre et les principes généraux de fonctionnement du contrat.\nLes conditions particulières qui sont signées par l’assureur et l’assuré,\nLes conventions ou dispositions spéciales qui définissent les garanties pouvant être accordées par le contrat(seules sont acquises celles dont mention est faite aux conditions particulières).\nÉventuellement les annexes, intercalaires, clauses dont il fait mention aux conditions particulières.',
      },
      {
        title: 'CONTRE EXPERTISE: ',
        description:
          'en cas de litige, de désaccord ou pour sauvegarder leurs intérêts réciproques, les parties(assureurs, assurés, tiers...) peuvent provoquer une contre - expertise : constatation des dommages, des blessures subies par les victimes contradictoirement par l’expert et par le contre expert.',
      },
      {
        title: 'COTISATION: ',
        description:
          'somme due par le souscripteur d’un contrat d’assurance en contre partie des garanties accordées par l’assureur.',
      },
      {
        title: "COURTIER D'ASSURANCES :",
        description:
          'Professionnel indépendant ayant la qualité de commerçant, le courtier d’assurances sert d’intermédiaire entre ses clients et les compagnies d’assurances, son objectif étant in fine de trouver les produits les mieux adaptées à sa clientèle.\nLe courtier représente ses clients et défend leurs intérêts.Il les conseille, négocie avec les compagnies d’assurances et les assiste dans le règlement des sinistres.\n Mandataire de son client, il est rémunéré par la compagnie d’assurances en tant qu’apporteur d’affaires.Sa responsabilité civile professionnelle peut être recherchée s’il manque à son devoir de conseil.Toutefois, s’il se présente comme le mandataire d’une compagnie d’assurances, il engage alors la responsabilité de celle - ci.',
      },
    ],
  },
  {
    Alphab: 'D',
    words: [
      {
        title: 'DATE D’EFFET: ',
        description:
          'Date à laquelle le contrat (ou l’avenant) prend effet (prise d’effet de la garantie)',
      },
      {
        title: 'D.D.E.ou DEGATS DES EAU: ',
        description:
          ' police risques divers ou garantie supplémentaire dans certaines polices couvrant les dommages subis par le bâtiment, le mobilier ou le matériel suite à des fuites d’eau...',
      },
      {
        title: 'DEDOMMAGEMEN: ',
        description:
          'c’est la procédure d’indemnisation d’une personne dans le cadre de la responsabilité civile.',
      },
      {
        title: 'DECLARATION DU RISQU: ',
        description:
          'Le fait pour un assuré, de fournir à l’assureur toutes les informations nécessaires à la tarification et à l’établissement du contrat.',
      },
      {
        title: 'DEFENSE & RECOUR: ',
        description:
          'garantie facultative existant en automobile et dans certaines polices obligeant l’assureur:\nEn cas de poursuites pénales engagées contre son client, à le défendre en constituant un avocat;\nEt à exercer un recours amiable ou judiciaire pour dé fendre ses intérêts.',
      },
      {
        title: 'DETERIORATIONS IMMOBILIERE: ',
        description:
          'dégâts subis par les bâtiments, aux embellissements, aux portes..., des locaux assurés.',
      },
      {
        title: 'DOMMAGES: ',
        description: 'Perte ou préjudice subi par une personne ou un bien.',
      },
      {
        title: 'DOMMAGES CORPOREL: ',
        description: 'Dommages subis par les personnes physiques.',
      },
      {
        title: 'DOMMAGES ELECTRIQUES: ',
        description:
          'accident d’origine électrique causant des dommages aux appareils électriques et aux canalisations électriques non enterrés.',
      },
      {
        title: 'DOMMAGES IMMATERIEL: ',
        description:
          'Dommages qui résultent de la privation de jouissance d’un droit, de l’interruption d’un service ou d’une perte de bénéfice espéré.',
      },
      {
        title: 'DOMMAGES MATERIELS: ',
        description:
          'Dommages atteignant les biens meubles ou immeubles, les animaux.',
      },
      {
        title: 'DOMMAGES COLLISION: ',
        description:
          ' garantie optionnelle couvrant les dommages subis par le véhicule assuré suite à un accident avec un autre véhicule ou un piéton que l’assuré soit responsable ou non.',
      },
      {
        title: 'DUREE DU CONTRAT: ',
        description:
          ' Période pour laquelle est souscrit le contrat, soit au maximum un an pour tous les contrats souscrits par les particuliers(en dehors de l’assurance maladie).Pour les professionnels, la loi ne prévoit pas de durée légale.',
      },
    ],
  },
  {
    Alphab: 'E',
    words: [
      {
        title: 'ECHEANCE (de PRIME ou de COTISATION) : ',
        description: 'date à laquelle la cotisation est due.',
      },
      {
        title: 'EFFET : ',
        description:
          'date à partir de laquelle le risque est pris en charge par l’assureur.',
      },
      {
        title: 'EFFRACTION: ',
        description:
          'forcement ou la destruction de tout dispositif de fermeture ou de toute espèce de clôture.',
      },
      {
        title: 'EPAVE :(véhicule épave): ',
        description:
          "lorsque le coût des réparations suite à un sinistre automobile garanti dépasse la valeur du véhicule au jour du sinistre, le véhicule est déclaré épave (VEI = Véhicule Economiquement Irréparable) par l'expert qui plafonne son évaluation à la Valeur à dire d'expert .",
      },
      {
        title: 'ETENDUE TERRITORIALE: ',
        description:
          "L'étendue territoriale définit la portée géographique de la couverture, et par exemple, précise le nom des pays dans lesquels les garanties s'appliquent et ceux dans lesquels les garanties ne s'appliquent pas. Ces limites sont soit imposées par la loi, ou alors décidées par l'assureur pour maîtriser son risque.",
      },
      {
        title: 'EVALUATION : ',
        description:
          'coût approximatif d’un sinistre.Les évaluations des dommages permettent de déterminer le préjudice subi par les assurés ou par les tiers et de fixer le montant de leurs indemnités.',
      },
      {
        title: 'EVENEMENT : ',
        description:
          'toute circonstance susceptible de provoquer ou ayant provoqué un sinistre.',
      },
      {
        title: 'EXAMEN MEDICAL : ',
        description:
          'mesures d’instruction confiée à un médecin spécialisé dans l’expertise médicale, dans le but de renseigner l’assureur sur l’importance du préjudice corporel d’une victime.\nEn cas d’accident de la circulation, elle est faite à la demande de l’assureur du véhicule impliqué pour lui permettre de présenter à la victime une offre d’indemnité, dite offre transactionnelle.',
      },
      {
        title: 'EXCLUSION : ',
        description:
          'Ce qui n’est pas garanti par un contrat.Exemples : dommages volontaires, dommages causés à soi - même, amendes etc.Certaines exclusions sont absolues et d’autres sont relatives, c’est à dire qu’elles peuvent être supprimées moyennant surprime.',
      },
      {
        title: 'EXPERTISE : ',
        description:
          'Intervention, travail et conclusion de l’expert chargé par l’assureur de déterminer le montant des dommages subis par l’assuré lors d’un sinistre.L’expertise est dite «judiciaire» si l’expert est nommé par un tribunal.',
      },
      {
        title: 'EXPERTISE CONTRADICTOIRE : ',
        description:
          "La société d'assurances désigne un expert ; l'assuré en choisit un autre.Les experts tenteront alors de se mettre d'accord. En cas de désaccord, ils en désignent un troisième et les décisions sont prises à la majorité.",
      },
      {
        title: 'EXTENSION DE GARANTIE: ',
        description:
          'garantie ajoutée au contrat de base à la demande du souscripteur, et généralement moyennant un complément de prime.',
      },
    ],
  },
  {
    Alphab: 'F',
    words: [
      {
        title: 'FAUSSE DECLARATION : ',
        description:
          'Déclaration inexacte de l’assuré sur les éléments servant de base à l’établissement du contrat ou sur les antécédents. La fausse déclaration peut, suivant les circonstances, donner lieu à l’établissement d’un nouveau contrat, à sa résiliation ou à sa nullité, ou au règlement partiel d’un sinistre.',
      },
      {
        title: 'FERME: ',
        description:
          'par opposition aux polices renouvelables par tacite reconduction, les polices dites fermes, sont résiliées automatiquement à leur échéance.',
      },
      {
        title: 'FORFAIT:  DOMMAGES: ',
        description:
          'il peut arriver que les experts avec les parties lésées n’arrivent pas à déterminer avec exactitude le montant des dommages subis.Dans ce cas, ils s’arrangent pour attribuer un forfait d’un commun accord pour mettre fin au litige.',
      },
      {
        title: 'F.M.P.ou FRAIS MEDICAUX ET PHARMACEUTIQUES: ',
        description:
          'ce sont les frais engagés par la victime pour se soigner: honoraires des médecins, médicaments, frais des cliniques...pris en charge par les assureurs loi, par les assurances de personnes: individuelle, PTA, Maladie...et par la R.C.automobile.',
      },
      {
        title: ' FRACTIONNEMENT : ',
        description:
          'Périodicité de paiement d’une prime.Il peut être annuel, semestriel, trimestriel...avec une légère augmentation de la prime.',
      },
      {
        title: 'FRANCHISE: ',
        description:
          'Part de dommage que l’assuré conserve à sa charge.Elle peut être fixe ou proportionnelle au montant des dommages avec minimum / maximum.Elle peut être absolue ou relative.',
      },
    ],
  },
  {
    Alphab: 'G',
    words: [
      {
        title: 'GARAGES CONVENTIONNES : ',
        description:
          'pour rendre un meilleur service à nos assurés, certains réparateurs automobiles ont été agréés par notre Compagnie dans plusieurs villes du royaume pour réparer à nos charges, sous certaines conditions, leur(s) véhicule(s).',
      },
      {
        title: 'GARANTIE : ',
        description:
          'Engagement de l’assureur de couvrir un risque.L’assureur délivre ou accorde sa garantie pour tel ou tel risque.',
      },
    ],
  },
  {
    Alphab: 'I',
    words: [
      {
        title: 'INCAPACITES : ',
        description: 'on distingue plusieurs incapacités : ',
      },
      {
        title: 'I.P.P.ou INCAPACITE PERMANENTE PARTIELLE : ',
        description:
          'Diminution de l’intégrité physique d’une personne, par suite de maladie ou d’accident, et dont l’état ne peut plus évoluer, ni positivement, ni négativement, c’est à dire que l’on dit que son état est consolidé.Elle est exprimée par les médecins en pourcentage.',
      },
      {
        title: 'I.P.T.ou INCAPACITE PERMANENTE TOTALE : ',
        description:
          'dans ce cas, la personne est dans l’incapacité de se livrer à une quelconque activité lui procurant gain ou profit telles que la cécité, la folie, la paraplégie...elle équivaut à 100 % d’I.P.P…',
      },
      {
        title:
          'I.T.T.ou INCAPACITE TOTALE TEMPORAIRE ou encore INDEMNITE JOURNALIERE : ',
        description:
          'Allocation versée à une personne mise dans l’incapacité de se livrer à ses occupations habituelles(professionnelles ou non), pour chaque jour d’incapacité.',
      },
      {
        title: 'INCENDIE : ',
        description: 'Feu qui se propage et fait des ravages.',
      },
      {
        title: 'INDEMNITE : ',
        description:
          'Somme qui, conformément aux dispositions du contrat, est versée par l’assureur à l’occasion d’un sinistre, après déduction éventuelle de la vétusté et de la franchise.\nL’indemnité peut aussi être versée à la victime d’un accident causé par un tiers.',
      },
      {
        title: 'INTERMEDIAIRE : ',
        description:
          'L’agent général, ou le courtier qui fait souscrire le contrat et peut effectuer les tâches d’encaissement et de gestion.',
      },
    ],
  },
  {
    Alphab: 'M',
    words: [
      {
        title: 'MISE EN DEMEURE (POUR NON PAIEMENT DE PRIME) : ',
        description:
          'Injonction de payer adressée par l’assureur à l’assuré qui n’a pas réglé une prime dans les délais impartis.\nLa mise en demeure doit être faite dans les conditions fixées par le Code des Assurances.Elle a pour effet de suspendre les garanties du contrat dans le délai de 20 jours et de le résilier 10 jours après.',
      },
      {
        title: 'MULTIRISQUE: ',
        description:
          'contrats qui comportent plusieurs garanties spécifiques:\nIncendie, Vol, Dégât des eaux, Responsabilité Civile…',
      },
    ],
  },
  {
    Alphab: 'N',
    words: [
      {
        title: 'NULLITE DU CONTRAT: ',
        description:
          'quand le contrat est entaché par une fausse déclaration grave de la part de l’assuré –dans le but d’induire en erreur l’assureur – le contrat en question est sensé n’avoir jamais existé et les primes réglées restent acquises à l’assureur en guise d’indemnité.',
      },
    ],
  },
  {
    Alphab: 'O',
    words: [
      {
        title: 'OBLIGATIONS CONTRACTUELLES : ',
        description:
          'selon le contrat conclu, l’assuré s’oblige à payer la prime ou la cotisation et l’assureur à payer l’indemnité à son client en cas de réalisation du risque.',
      },
    ],
  },
  {
    Alphab: 'P',
    words: [
      {
        title: 'PARTS DE RESPONSABILITE : ',
        description:
          'En matière de responsabilité civile, les indemnités sont calculées en tenant compte du taux de responsabilité incombant à l’auteur du fait dommageable.',
      },
      {
        title: 'POLICE : ',
        description:
          'Document qui matérialise, constate la preuve de l’accord et des engagements de l’assureur et du souscripteur pour la couverture du risque.\nLa police d’assurance est constituée des :\n- Condition Générales qui sont habituellement des dispositions pré imprimées, définissant le cadre et les principes généraux du contrat et des :\n- Conditions Particulières qui sont des dispositions spéciales qui adaptent la police d’assurance à chaque cas particulier (souscripteur, assuré, adresse, capitaux, conditions tarifaires...).\nIl y a lieu de signaler qu’en cas de contradiction entre les deux Conditions, c’est les Conditions Particulières qui prévalent.',
      },
      {
        title: 'PREAVIS : ',
        description:
          'Délai que doit respecter la partie qui demande la résiliation pour que celle-ci soit acceptable par l’autre partie. Ce délai impératif diffère d’une branche à une autre.',
      },
      {
        title: 'PREJUDICE : ',
        description: 'Dommage subi par une personne physique ou morale.',
      },
      {
        title: 'PRIME D’ASSURANCE ou COTISATION : ',
        description:
          'somme versée par l’assuré à l’assureur en contrepartie de la prise en charge du risque.',
      },
      {
        title:
          'P. T. A. ou PERSONNES TRANSPORTEES AUTOMOBILES ou encore SECURITE ROUTIERE : ',
        description:
          'elle couvre 5 personnes, quelles qu’elles soient (tiers ou non), blessées dans le véhicule assuré suite à un accident de la circulation.',
      },
    ],
  },
  {
    Alphab: 'Q',
    words: [
      {
        title: 'QUITTANCE D’INDEMNITE : ',
        description:
          'Document soumis à la signature de l’assuré ou d’un tiers en contrepartie du paiement d’un sinistre.',
      },
      {
        title: 'QUITTANCE DE PRIME (ou de COTISATION) : ',
        description:
          'Document remis à l’assuré en contrepartie du paiement de sa prime (ou de sa cotisation).',
      },
    ],
  },
  {
    Alphab: 'R',
    words: [
      {
        title: 'RECOURS : ',
        description:
          "Réclamation d'une victime auprès du responsable de son préjudice.",
      },
      {
        title: 'RENTE: ',
        description:
          'en accidents de travail ou assurance vie: montant distribué aux bénéficiaires périodiquement. Elle peut être viagère, toute la vie du bénéficiaire, comme elles peuvent être limitées dans le temps.',
      },
      {
        title: 'RESILIATION : ',
        description:
          ' Dénonciation du contrat. Elle est habituellement demandée par l’une des parties à l’échéance principale. Elle peut être demandée en dehors de cette date lors de circonstances particulières :\n- Pour l’assuré en cas de disparition ou de modification du risque,\n- Pour l’assureur, en cas d’aggravation du risque, en cas de sinistre ou en cas de non paiement de la prime par l’assuré.',
      },
      {
        title: 'RESPONSABILITE CIVILE : ',
        description:
          "L'assurance de responsabilité civile a pour objet de garantir les conséquences pécuniaires de la responsabilité civile encourue par les personnes couvertes par le contrat. ",
      },
      {
        title: 'RESPONSABILITE CIVILE(vie privée) : ',
        description:
          "Obligation légale pour toute personne de réparer les dommages causés à autrui.Les dommages causés par son fait, par sa négligence, son imprudence, par les enfants, préposés, animaux ou choses que l'on a sous sa garde, immeubles dont on est propriétaire.",
      },
      {
        title: 'RISQUE : ',
        description:
          'Evènement futur et aléatoire contre lequel l’assuré veut se prémunir.C’est aussi le bien sur lequel porte l’assurance.',
      },
    ],
  },
  {
    Alphab: 'S',
    words: [
      {
        title: 'SINISTRE : ',
        description:
          "Réalisation de l'événement couvert par le contrat et qui donne lieu aux prestations assurées : indemnité, capital ou rente, assistance...",
      },
      {
        title: 'SOUSCRIPTEUR : ',
        description:
          "Personne qui signe le contrat et paie les cotisations.Parfois à distinguer de l'assuré ou du bénéficiaire.",
      },
      {
        title: 'SUBROGATION: ',
        description:
          "Lorsque le dommage subi par l'assuré est le fait d'un tiers, l'assureur indemnise son assuré et peut exercer un recours contre le tiers responsable pour son propre compte à concurrence du montant de l'indemnité qu'il a versé. On dit que l'assureur est 'subrogé' dans les droits et actions de l'assuré contre le tiers responsable.",
      },
      {
        title: 'SUSPENSION DES GARANTIES : ',
        description:
          'Interruption provisoire de la garantie du contrat.Elle suspend temporairement les obligations de l’assureur mais pas celles de l’assuré notamment en matière de paiement des primes.',
      },
      {
        title: 'SUSPENSION DU CONTRAT: ',
        description:
          'Interruption provisoire des obligations découlant du contrat.Elle est demandée par l’assuré et s’effectue après accord écrit de l’assureur.',
      },
    ],
  },
  {
    Alphab: 'T',
    words: [
      {
        title: 'TACITE RECONDUCTION : ',
        description:
          'Renouvellement automatique du contrat à l’expiration de la durée initiale. Un contrat d’un an avec tacite reconduction sera reconduit d’année en année sauf dénonciation par l’une des deux parties.',
      },
      {
        title: 'TAXE(d’assurance) : ',
        description:
          'impôt calculé en pourcentage(%) de la prime, et recouvré par les entreprises d’assurances pour le compte du Trésor Public.',
      },
      {
        title: 'TERRITORIALITE : ',
        description:
          'les polices, la Carte Verte ainsi que la Carte Orange font état des pays où peut s’exercer valablement les garanties.',
      },
      {
        title: 'TICKET MODERATEUR : ',
        description:
          "C'est ce qui reste à la charge de l'assuré social.C'est donc l'écart entre le tarif de convention et le montant remboursé par la Sécurité Sociale.C'est ce qui n'a pas été remboursé par la Sécurité Sociale et qui peut faire l'objet d'un remboursement complémentaire grâce à une complémentaire maladie(une 'mutuelle').",
      },
      {
        title: 'TIERS : ',
        description:
          'se dit de toute personne avec laquelle on n’a aucun lien juridique.Les personnes ayant la qualité de TIERS, peuvent prétendre à une indemnisation en matière de Responsabilité Civile.',
      },
      {
        title: 'TOUS RISQUES : ',
        description:
          'En Automobile, police englobant toutes les garanties: R.C., Tierce, Vol, Incendie, BDG et Défense Recours.',
      },
    ],
  },
  {
    Alphab: 'V',
    words: [
      {
        title: 'VALEUR : ',
        description: 'c’est la valeur marchande d’un objet. On distingue : ',
      },
      {
        title: 'VALEUR ASSUREE : ',
        description:
          'somme déclarée par les assurés à la souscription d’un contrat.',
      },
      {
        title: 'VALEUR A NEUF : ',
        description:
          "La valeur à neuf est, pour le bâtiment, le prix coûtant de sa reconstruction à neuf (ou de sa réparation), y compris les taxes, les honoraires d'architecte, et pour le mobilier, le prix coûtant de sa reconstitution à neuf (ou de sa réparation).",
      },
      {
        title: 'VALEUR de REMPLACEMENT : ',
        description:
          'Coût réel d’un bien de même nature, de même ancienneté et dans le même état d’entretien que le bien endommagé.',
      },
      {
        title: 'VALEUR VENALE : ',
        description:
          "La valeur vénale est le prix d'un bien que l'assuré obtiendrait normalement s'il le mettait en vente sur le marché national.",
      },
      {
        title: 'VANDALISME: ',
        description:
          'Détériorations ou destructions mobilières ou immobilières commises volontairement par un tiers.',
      },
      {
        title: 'VEHICULE TERRESTRE A MOTEUR: AUTOMOBILE: ',
        description:
          'tout véhicule mu par un moteur doit être assuré en responsabilité civile auprès d’une compagnie d’assurance ou une mutuelle.\nLa conduite des véhicules dont la cylindrée dépasse 49 cm3 nécessite un permis de conduire.',
      },
      {
        title: 'VETUSTE : ',
        description:
          'Valeur de la dépréciation d’un bien par rapport à sa valeur à neuf.Elle n’est pas proportionnelle à l’ancienneté du bien, mais estimée suivant l’état réel du bien par rapport à un bien neuf de même nature.',
      },
      {
        title: 'VOL : ',
        description:
          'le code pénale qualifie le vol de: « soustraction frauduleuse d’un objet appartenant à autrui ».Le vol se caractérise donc par le fait de s’arroger la détention matérielle d’une chose contre le gré de son propriétaire ou de son détenteur naturel, peu importe que l’objet soit ensuite détruit ou abandonné.',
      },
    ],
  },
];
export const Lexique = {
  fr: LexiqueFr,
  ar: LexiqueAr,
};
